export default __webpack_public_path__ + "static/media/fondo.3121c2c0.jpg";